/* eslint-disable react/no-deprecated */
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import GoogleMapReact from 'google-map-react';
import _ from 'lodash';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import * as actions from '../../actions/index';
import Etiquette from '../Etiquette';
import {
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_PREPARING,
  API_KEY,
  mainColor,
  UNIT
} from '../../constants';
import { getPins, getMapCenter } from './MapOrders.services';
import { styles } from './MapOrders.styles';
import { isObjectNotEmpty } from '../../utils/tools';

class MapOrders extends React.Component {
  state = {
    centerDef: { lat: 43.706023, lng: 7.263286 },
    zoom: 12,
    zoomDef: 12,
    drivers: null,
    center: { lat: 43.706023, lng: 7.263286 }
  };

  componentWillMount() {
    getPins(this.props, this);
  }

  componentWillReceiveProps(nextProps) {
    getPins(nextProps, this);
    if (!_.isEqual(nextProps.driversRealTime, this.props.driversRealTime) && this.props.zoom) {
      const newCenter = getMapCenter(this);
      this.setState({ center: newCenter });
    }
  }


  renderDriversPins = () => {
    const { drivers, orders } = this.state;
    const returnDrivers = [];
    orders.forEach(order => {
      const { idDep } = order;
      const driver = _.find(drivers, (driver, key) => driver.driverId === idDep);
      if (driver) {
        returnDrivers.push(driver);
      }
    });
    return returnDrivers.map((driver, i) => {
      const { lat, long, firstName } = driver;
      return (
        <Etiquette
          style={{
            opacity: 0.8
          }}
          backColor={mainColor.colorWhite}
          key={i.toString()}
          lat={lat}
          lng={long}
          text={`${firstName}`}
          hideArrow
        >
          <DirectionsBikeIcon style={{ alignSelf: 'center', marginTop: UNIT * 0.25 }} />
        </Etiquette>
      );
    });
  };

  renderOrdersPins = () => {
    const { orders } = this.state;
    return (
      orders &&
      orders.map((e, i) => {
        const { address, orderNumber, status } = e;
        if (address) {
          const { location = {} } = address;
          const { longitude = null, latitude = null } = location;
          return (
            isObjectNotEmpty(address) && (
              <Etiquette
                backColor={
                  status === ORDER_PHASE_CONTACTING
                    ? 'rgba(255, 0, 0, 0.8)'
                    : status === ORDER_PHASE_PREPARING
                      ? 'rgba(255, 180, 0, 0.8)'
                      : 'rgba(22, 247, 60, 0.8)'
                }
                style={{
                  transform: 'translate(-50%,-50%)'
                }}
                key={i.toString()}
                lat={latitude}
                lng={longitude}
                text={`#${orderNumber}`}
              />
            )
          );
        }
      })
    );
  };

  render() {
    const { isLoading, classes, isPaperDisplay, style, zoomDef = this.state.zoomDef, zoom = this.state.zoom } = this.props;
    const { center, centerDef } = this.state;
    return (
      <div className={isPaperDisplay ? classes.paperContainer : classes.modal} style={style}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: API_KEY,
            language: 'fr'
          }}
          defaultCenter={centerDef}
          center={zoom ? getMapCenter(this) : center}
          defaultZoom={zoomDef}
          zoom={zoom}

        >
          {!isLoading ? this.renderOrdersPins() : null}
          {!isLoading ? this.renderDriversPins() : null}
        </GoogleMapReact>
      </div>
    );
  }
}

const mapStateToProps = ({ user, firebaseRealTime }) => {
  const { address = {} } = user;
  const { location = {} } = address;
  const { latitude, longitude } = location;
  const { drivers = [], independentDrivers = [], externalDrivers } = firebaseRealTime;
  return {
    locationShop: {
      lat: parseFloat(latitude),
      lng: parseFloat(longitude)
    },
    driversRealTime: [...drivers, ...independentDrivers],
    externalDrivers: _.map(externalDrivers, (driver, key) => { return { ...driver, driverId: key } })
  };
};

export default withStyles(styles)(connect(mapStateToProps, actions)(MapOrders));
